import Blank from "@/layouts/blank.vue";
import VehicleAssetAvailabilityList from "@/pages/admin/assets_availability_dashboard/dashboard/VehicleAvailabilityDashboard.vue";
import NewVehicleAssetAvailabilityList from "@/pages/admin/assets_availability_dashboard/dashboard/NewVehicleAvailabilityDashboard.vue";

const vehicleAvailabilityRoutes = [
  {
    path: "dashboard",
    name: "app-admin-asset-availability",
    component: Blank,
    children: [
      {
        path: "list",
        name: "app-admin-asset-availability-list",
        component: VehicleAssetAvailabilityList,
      },
       {
        path: "asset-list",
        name: "app-admin-asset-new-availability-list",
        component: NewVehicleAssetAvailabilityList,
      },
    ],
  },
];

export default vehicleAvailabilityRoutes;
